import { FC } from "react";

interface HouseIconSVGProps {
    className?: string;
}

const HouseIconSVG: FC<HouseIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M10 13.9984V8.66502C10 8.48821 9.92976 8.31864 9.80474 8.19361C9.67971 8.06859 9.51014 7.99835 9.33333 7.99835H6.66667C6.48986 7.99835 6.32029 8.06859 6.19526 8.19361C6.07024 8.31864 6 8.48821 6 8.66502V13.9984M2 6.66502C1.99995 6.47106 2.04222 6.27943 2.12386 6.1035C2.20549 5.92756 2.32453 5.77155 2.47267 5.64635L7.13933 1.64702C7.37999 1.44362 7.6849 1.33203 8 1.33203C8.3151 1.33203 8.62001 1.44362 8.86067 1.64702L13.5273 5.64635C13.6755 5.77155 13.7945 5.92756 13.8761 6.1035C13.9578 6.27943 14 6.47106 14 6.66502V12.665C14 13.0186 13.8595 13.3578 13.6095 13.6078C13.3594 13.8579 13.0203 13.9984 12.6667 13.9984H3.33333C2.97971 13.9984 2.64057 13.8579 2.39052 13.6078C2.14048 13.3578 2 13.0186 2 12.665V6.66502Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default HouseIconSVG;
